module.exports = __webpack_public_path__ + "static/media/CodexAcquired.bc312bd0.mp3";